function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Navbar, NavbarToggler } from 'reactstrap';
import styled from 'styled-components';
import Theme from '../modules/Theme';
import SearchForm from '../components/SearchForm';
import ProductNav from '../components/ProductNav';
import { itemPropTypes } from '../components/NavItem';
import OutdatedBrowserModal from '../components/OutdatedBrowserModal';
var ProductNavbar = styled(Navbar).withConfig({
  displayName: "ProductBar__ProductNavbar",
  componentId: "sc-8xegtc-0"
})(["background-color:", ";box-shadow:0px 0px 5px #707070;margin-top:100px;z-index:1029 !important;min-height:75px;padding:0.5rem 0.5rem;.navbar-nav{.nav-item{margin-left:0.5rem !important;margin-right:0.5rem !important;line-height:20px;font-size:120%;font-weight:700;.dropdown-toggle.active{background-color:", ";}a.dropdown-toggle.selected,a.active{background-color:", ";&:hover{color:white !important;}}a.dropdown-toggle{border-radius:5px;}}.nav-item + .nav-item{margin-left:0;}.nav-link,.navbar-text{padding:1rem !important;}.nav-link:hover{color:", " !important;}}.dropdown-menu{background-color:", ";}"], Theme.primary, Theme.primary, Theme.dark, Theme.dark, Theme.primary);

var ProductBar = /*#__PURE__*/function (_Component) {
  _inherits(ProductBar, _Component);

  function ProductBar(props) {
    var _this;

    _classCallCheck(this, ProductBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductBar).call(this, props));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(ProductBar, [{
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          site = _this$props.site,
          onSearchQueryChanged = _this$props.onSearchQueryChanged,
          performSearch = _this$props.performSearch,
          searchMethod = _this$props.searchMethod,
          searchParameterName = _this$props.searchParameterName,
          searchURL = _this$props.searchURL;
      var searchForm = null;

      if (!this.props.nosearch) {
        searchForm = /*#__PURE__*/React.createElement("div", {
          className: "mr-auto ml-auto"
        }, /*#__PURE__*/React.createElement(SearchForm, {
          method: searchMethod,
          onSearchQueryChanged: onSearchQueryChanged,
          performSearch: performSearch,
          searchParameterName: searchParameterName,
          searchURL: searchURL
        }));
      }

      return /*#__PURE__*/React.createElement(ProductNavbar, {
        dark: true,
        expand: "md",
        fixed: "top"
      }, /*#__PURE__*/React.createElement(OutdatedBrowserModal, null), /*#__PURE__*/React.createElement(NavbarToggler, {
        onClick: this.handleClick
      }), /*#__PURE__*/React.createElement(Collapse, {
        isOpen: this.state.isOpen,
        navbar: true
      }, /*#__PURE__*/React.createElement(ProductNav, {
        active: this.props.page,
        className: "mr-auto",
        items: this.props.items,
        site: site
      }), searchForm));
    }
  }]);

  return ProductBar;
}(Component);

_defineProperty(ProductBar, "propTypes", {
  items: PropTypes.arrayOf(PropTypes.shape(itemPropTypes)).isRequired,
  nosearch: PropTypes.bool,
  onSearchQueryChanged: PropTypes.func,
  page: PropTypes.string.isRequired,
  performSearch: PropTypes.func,
  searchMethod: PropTypes.oneOf(['get', 'post']),
  searchParameterName: PropTypes.string,
  searchURL: PropTypes.string,
  site: PropTypes.string.isRequired
});

export default ProductBar;